
import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { FormGroup, RadioButton, DateInput } from '../../../../../../../../components/form/form';

import { useValidation } from '../../../../../../../../hooks/use-validation';
import { securityTypeAndFormObj, securityTypeAndFormValidator} from '../../../../../../../../form-control/listing-form/security-info-control';
import { getSecurityTypes, getSecurityClass, getSecurityForm, getMannerOfDistribution, getNumberOfSecurity} from '../../../../../../../../helpr/listingFormData';
import styles from './security-type-and-form.module.scss';

const SecurityTypeAndForm = ({listingInfo, saveListingInfo, nextStep}) => {
  const listingFormState = useValidation(securityTypeAndFormValidator, securityTypeAndFormObj(listingInfo), {border: '1px solid red'});
  const { getRadioButtonProps, validate } = listingFormState;

  const nextHandler = () => {
    const {isFormValid, formState} = validate();
    if( isFormValid ){
      saveListingInfo(formState);
      nextStep();
    }
  }

  return (
    <div className={styles['security-type-form-component']}>
      <Row>
          <Col>
            <FormGroup header="TYPE OF SECURITY:*">
              <RadioButton
                inputProps={getRadioButtonProps('securityType')}
                data={getSecurityTypes(getRadioButtonProps('securityType'))}
                othersOption={true}/>
            </FormGroup>
            <FormGroup header="SECURITY CLASS">
              <RadioButton
                inputProps={getRadioButtonProps('securityClass')}
                data={getSecurityClass(getRadioButtonProps('securityClass'))}/>
            </FormGroup>
            <FormGroup header={"FORM OF SECURITY:*"}>
              <RadioButton inputProps={getRadioButtonProps('securityForm')} data={getSecurityForm()} othersOption={true}/>
            </FormGroup>
            <FormGroup header="MANNER OF DISTRIBUTION:*">
              <RadioButton inputProps={getRadioButtonProps('mannerOfDistrib')} data={getMannerOfDistribution()}/>
            </FormGroup>
            <FormGroup header="NUMBER OF SECURITY:*">
              <RadioButton
                disabled={listingInfo['isPublished']}
                inputProps={getRadioButtonProps('numberOfSecurity')}
                data={getNumberOfSecurity()}/>
            </FormGroup>
        </Col>
      </Row>
      <Row className={styles['btn-actions']}>
        <Button onClick={()=>nextHandler()}>NEXT</Button>
      </Row>
    </div>
  )
}

export default SecurityTypeAndForm;

